import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { requiredFileType } from '../../../../shared/validators/required-file-type.validator';
import { FileService } from '../../../../shared/services/file.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface DialogData {
  fileId: string;
  field: string;
  title: string;
  description: string;
  professionalId: string;
}

@Component({
  selector: 'app-modal-file',
  templateUrl: './modal-file.component.html',
  styleUrls: ['./modal-file.component.scss'],
})
export class ModalFileComponent implements OnInit {
  fileForm: FormGroup = new FormGroup({
    file: new FormControl(''),
  });

  progressFilesUpload: number = 0;

  constructor(
    private formBuilder: FormBuilder,
    private fileService: FileService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ModalFileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    this.fileForm = this.formBuilder.group({
      file: [
        '',
        [Validators.required, requiredFileType('png, jpg, jpeg, pdf')],
      ],
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  hasErrorFile(controlName: string, errorName: string) {
    return this.fileForm.controls[controlName].hasError(errorName);
  }

  onSubmitFile() {
    this.fileService
      .update(
        this.fileForm.value.file,
        this.data.fileId,
        this.data.field,
        this.data.description,
        this.data.professionalId
      )
      .subscribe({
        next: (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progressFilesUpload = Math.round(
              (100 * event.loaded) / event.total
            );
          } else if (event instanceof HttpResponse) {
            this.snackBar.open(
              'Arquivo salvo com sucesso!',
              'OK',
              {
                duration: 4000,
              }
            );

            this.onNoClick();
          }
        },
        error: (err: any) => {
          this.snackBar.open(
            'Não foi possível salvar o arquivo, tente novamente mais tarde!',
            'OK',
            {
              duration: 3000,
            }
          );
        },
      });
  }
}
